<template>
  <div v-if="filterOptions && Object.keys(filterOptions).length" class="cl__tf">
    <div :class="['cl__tf-item', { checked: checkedOptions.length === 0 }]" tabindex="0">
      <div class="cl__tf-label" @click="allBtnClick">All</div>
    </div>
    <div
      v-for="(count, name) in filterOptions"
      :key="name"
      :class="['cl__tf-item', { checked: checkedOptions.some((option) => option === name) }]"
    >
      <input
        class="cl__tf-checkbox"
        type="checkbox"
        :value="name"
        :id="name"
        :checked="checkedOptions.some((option) => option === name)"
        @change="(e) => updateCheckedInput(e, 'type', name)"
      />
      <label class="cl__tf-label" :for="name"> {{ name }}</label>
    </div>
  </div>
</template>

<script setup>
  import { ref, toRefs, watch } from 'vue';

  const props = defineProps({
    filterOptions: {
      type: Object,
      required: true,
    },

    appliedFilters: {
      type: Array,
      default: () => [],
    },
  });

  const { filterOptions, appliedFilters } = toRefs(props);

  const emit = defineEmits(['updateAppliedFilters']);
  const checkedOptions = ref([]);

  const updateCheckedInput = (event, type, option) => {
    if (event.target.checked) {
      checkedOptions.value = [...checkedOptions.value, option];
    } else {
      checkedOptions.value = checkedOptions.value.filter((checkedOption) => checkedOption !== option);
    }

    emit('updateAppliedFilters', type, checkedOptions.value);
  };

  const allBtnClick = () => {
    checkedOptions.value = [];
    emit('updateAppliedFilters', 'type', checkedOptions.value);
  };

  watch(appliedFilters, (value) => {
    const newCheckedOptions = value || [];
    const current = checkedOptions.value;

    if (current.length !== newCheckedOptions.length ||
        current.some((v, i) => v !== newCheckedOptions[i])) {
      checkedOptions.value = newCheckedOptions;
    }
  });
</script>
